import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import { CssBaseline } from '@mui/material';
import Disclaimer from '../../components/disclaimer/desclaimer';
import WSRODashboardProps from '../../assets/props/wsro-props';
import { KeyCloakClient, KeyCloakProviderConfig } from '../../keycloak/keycloak-client';
import { Paper } from '@mui/material';
import NavBar from '../../components/navbar/navbar';


type Props = {};
type State = {
	isLoading: boolean;
	error: string;
	errorOpen: boolean;
	user: any;
	isSuccess: boolean;
	successMessage: string;
	userAcceptEnabled: boolean;
	isAuthenticated: boolean;
};

const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.612.0');
const QlikConnection = {
	host: 'analytics.cremedatafoundry.com',
	port: '',
	prefix: '',
	isSecure: true,
	// appId: '42a60ac7-e50a-42a9-8313-a2bc319886ba',
	appId: 'efd73c80-b9e7-45a0-bb7f-5f16e15106b9', // new app id
};

export default class Dashboard extends React.Component<Props, State> {
	constructor(props: Props) {
		const userIsLogin = localStorage.getItem('userIsLogin') ? localStorage.getItem('userIsLogin') : 'false';
		if (userIsLogin === 'false') {
			window.location.href = '/sign-up';
		} else {
			window.location.href = '/sign-sso';
		}
		super(props);
		this.state = {
			isLoading: true,
			isAuthenticated: false,
			user: {},
			isSuccess: false,
			successMessage: '',
			userAcceptEnabled: false,
			error: '',
			errorOpen: false,
		};
	}

	render() {
		return (
			<Paper
			>
				<CssBaseline />
				<NavBar props={WSRODashboardProps.navbar} />
				{this.state.userAcceptEnabled ? (
					<div>
						<iframe id="qLikIFrame" src={'https://analytics.cremedatafoundry.com/sense/app/efd73c80-b9e7-45a0-bb7f-5f16e15106b9/sheet/43f497ab-3285-46db-a87e-778fa60a4978/state/analysis'} style={{ border: 'none', width: '100%', height: '91vh' }}></iframe>
					</div>
				) : (
					<div>
						{/* <Disclaimer props={WSRODashboardProps.disclaimerProps} /> */}
					</div>
				)}
			</Paper>
		);
	}
}
